import { type FC } from "react";
import { Button } from "components/buttons/button/Button";
import { useNavigate } from "react-router";

import { RouteNames } from "../../../enums";
import Restricted from "../../../features/Application/Restricted";
import { addContentToPackPermissions } from "enums/rights";

export interface Props {}

const CreatePackButton: FC<Props> = () => {
  const navigate = useNavigate();

  return (
    <Restricted permissions={addContentToPackPermissions}>
      <Button
        primary
        className="create-pack create-button"
        onClick={() => navigate(`/${RouteNames.licensingPacks}/create`)}
      >
        Create Pack
      </Button>
    </Restricted>
  );
};

export default CreatePackButton;
